<sxw-side-dialog
  (onHideDialog)="hideDialog()"
  [(visible)]="isDialogVisible"
  appendTo="body"
  outletName="popups"
  theme="sxw-popup-cards"
  class="no-sidebar-header">
  <ng-template #header> </ng-template>
  <ng-template #content>
    <sxw-form #formElm [formModel]="formModel">
      <app-update-password-form></app-update-password-form>
      <sxw-button label="continue" class="mt-40px d-block submit-btn" (onClick)="submit()" [styles]="{ width: '100%' }" [isLoading]="isLoading">
      </sxw-button>
    </sxw-form>
  </ng-template>
</sxw-side-dialog>
